<template>
  <page-view :title="false">
    <a-card :bordered="false" v-show="!order.visible">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="订单号"
                ><a-input v-model="queryParam.orderNo" placeholder="订单号"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="支付流水号"
                ><a-input
                  v-model="queryParam.payBillno"
                  placeholder="支付流水号"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="支付类型">
                  <a-select
                    v-model="queryParam.payType"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="alipay">支付宝</a-select-option>
                    <a-select-option value="wechat">微信</a-select-option>
                    <a-select-option value="umspay">银联卡</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="支付状态">
                  <a-select
                    v-model="queryParam.paySta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="0">支付成功</a-select-option>
                    <a-select-option value="1">等待支付</a-select-option>
                    <a-select-option value="2">支付失败</a-select-option>
                    <a-select-option value="3">取消支付</a-select-option>
                    <a-select-option value="4">等待退款</a-select-option>
                    <a-select-option value="5">退款成功</a-select-option>
                    <a-select-option value="6">退款失败</a-select-option>
                    <a-select-option value="6">退款失败</a-select-option>
                    <a-select-option value="-1">支付异常</a-select-option>
                    <a-select-option value="7"
                      >交易结束,不可退款</a-select-option
                    >
                    <a-select-option value="8"
                      >未付款交易超时关闭</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button class="button-margin-left" @click="rest"
                  >重置</a-button
                >
                <a-button
                  type="primary"
                  icon="plus"
                  class="button-margin-left"
                  @click="add"
                  >购买合同</a-button
                >
                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 1950 }"
        showPagination="auto"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            <a-tag
              class="render-tag"
              color="#ed4014"
              v-if="record.paySta == '-1'"
              >支付异常</a-tag
            >
            <a-tag
              class="render-tag"
              color="#19be6b"
              v-if="record.paySta == '0'"
              >支付成功</a-tag
            >
            <a-tag
              class="render-tag"
              color="#2db7f5"
              v-if="record.paySta == '1'"
              >等待支付</a-tag
            >
            <a-tag
              class="render-tag"
              color="#ed4014"
              v-if="record.paySta == '2'"
              >支付失败</a-tag
            >
            <a-tag
              class="render-tag"
              color="#c5c8ce"
              v-if="record.paySta == '3'"
              >取消支付</a-tag
            >
            <a-tag
              class="render-tag"
              color="#ff9900"
              v-if="record.paySta == '4'"
              >等待退款</a-tag
            >
            <a-tag
              class="render-tag"
              color="#19be6b"
              v-if="record.paySta == '5'"
              >退款成功</a-tag
            >
            <a-tag
              class="render-tag"
              color="#ed4014"
              v-if="record.paySta == '6'"
              >退款失败</a-tag
            >
            <a-tag class="render-tag" color="grey" v-if="record.paySta == '7'"
              >交易结束,不可退款</a-tag
            >
            <a-tag
              class="render-tag"
              color="#17233d"
              v-if="record.paySta == '8'"
              >未付款交易超时关闭</a-tag
            >
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a class="a-action" @click="action(record, 'info')">查看</a>
          </template>
        </span>
        <span slot="tagPayItem" slot-scope="text, record">
          <template>
            <a-tag
              class="render-tag"
              color="#2d8cf0"
              v-if="record.payType == 'alipay'"
              >支付宝</a-tag
            >
            <a-tag
              class="render-tag"
              color="#00cc00"
              v-if="record.payType == 'wechat'"
              >微信</a-tag
            >
            <a-tag
              class="render-tag"
              color="#35e4e4"
              v-if="record.payType == 'umspay'"
              >银联卡</a-tag
            >
          </template>
        </span>
      </s-table>
    </a-card>
    <contract-order-info
      ref="orderInfo"
      :info="order.info"
      :visible="order.visible"
      @close="close"
    ></contract-order-info>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";
import ContractOrderInfo from "./ContractOrderInfo.vue";

export default {
  name: "ContractOrderList",
  components: {
    STable,
    PageView,
    ContractOrderInfo
  },
  data() {
    return {
      userInfo: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: "订单号",
          dataIndex: "orderNo",
          fixed: "left"
        },
        {
          title: "购买时间",
          dataIndex: "saleDate",
          width: 180
        },
        {
          title: "购买数量",
          dataIndex: "num",
          width: 120
        },
        {
          title: "总价(元)",
          dataIndex: "rateSum",
          width: 120
        },
        {
          title: "实际支付金额",
          dataIndex: "dirtyAmount",
          width: 150
        },
        // {
        //   title: "销售方式",
        //   dataIndex: "saleType",
        //   width: 110
        // },
        // {
        //   title: "销售渠道",
        //   dataIndex: "salesChannel",
        //   width: 120
        // },
        {
          title: "支付类型",
          dataIndex: "payType",
          scopedSlots: { customRender: "tagPayItem" },
          width: 120
        },
        {
          title: "支付状态",
          dataIndex: "paySta",
          scopedSlots: { customRender: "tagItem" },
          width: 150
        },
        {
          title: "支付时间",
          dataIndex: "payDatetime",
          width: 180
        },
        {
          title: "支付流水号",
          dataIndex: "payBillno",
          width: 220
        },
        {
          title: "备注",
          dataIndex: "remark",
          width: 300,
          ellipsis: true
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          width: 120,
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageMerchantOrder(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      },
      order: {
        info: {},
        visible: false
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.queryParam.merchantNo = this.userInfo.merchantNo;
  },
  methods: {
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "info") {
        this.order.info = record;
        this.order.visible = true;
      }
    },
    add() {
      this.$router.push({
        name: "AddContractOrder"
      });
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    rest() {
      this.queryParam = {};
      this.queryParam.merchantNo = this.userInfo.merchantNo;
    },
    close() {
      this.order.visible = false;
      this.order.info = {};
    }
  }
};
</script>
